import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Hizmetler = lazy(() => import('../pages/hizmetler/page'));
const Laboratuvar = lazy(() => import('../pages/laboratuvar/page'));
const Referanslar = lazy(() => import('../pages/referanslar/page'));
const Iletisim = lazy(() => import('../pages/iletisim/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/hizmetler',
    element: <Hizmetler />,
  },
  {
    path: '/laboratuvar',
    element: <Laboratuvar />,
  },
  {
    path: '/referanslar',
    element: <Referanslar />,
  },
  {
    path: '/iletisim',
    element: <Iletisim />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;